export default "__VITE_ASSET__pBZ4BeEp__"